module.exports = "/_next/static/images/PipeDataIntoWarehouse-f392b0c8daf0ca1468dc913e7ececbcc.webp";